import { Smartphone, Chrome } from 'lucide-react'
import { useDeviceDetect } from '../hooks/useDeviceDetect'
import HeroPhone from './HeroPhone'

const Hero = () => {
  const { isMobile } = useDeviceDetect()

  const primaryBtn = isMobile ? (
    <a
      href="#download"
      className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform w-full sm:w-auto"
    >
      <Smartphone className="w-5 h-5 mr-2" />
      Download the App
    </a>
  ) : (
    <a
      href="https://app.nearbies.co.uk"
      className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform w-full sm:w-auto"
    >
      <Chrome className="w-5 h-5 mr-2" />
      Open Web App
    </a>
  )

  const secondaryBtn = isMobile ? (
    <a
      href="https://app.nearbies.co.uk"
      className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-primary-700 bg-white border-2 border-primary-600 rounded-lg hover:bg-primary-50 transition-colors shadow-md hover:shadow-lg w-full sm:w-auto"
    >
      <Chrome className="w-5 h-5 mr-2" />
      Use Web App Instead
    </a>
  ) : (
    <a
      href="#download"
      className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-primary-700 bg-white border-2 border-primary-600 rounded-lg hover:bg-primary-50 transition-colors shadow-md hover:shadow-lg w-full sm:w-auto"
    >
      <Smartphone className="w-5 h-5 mr-2" />
      Download App
    </a>
  )

  return (
    <section className="relative overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Copy */}
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start mb-8">
              <img src="/nearbies-fw.png" alt="Nearbies Logo" className="mr-3" />
            </div>

            {/* Hero headline */}
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6">
              Discover Local Stores{' '}
              <span className="gradient-text">Near You</span>
            </h2>

            <p className="text-xl sm:text-2xl text-gray-600 mb-6 max-w-3xl mx-auto lg:mx-0">
              Find local businesses, browse their products, and order for pickup or delivery.
              Support your community, one order at a time.
            </p>

            <p className="text-sm font-medium text-primary-700 mb-8">Free to download · Works on iPhone, Android and the web</p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
              {primaryBtn}
              {secondaryBtn}
            </div>
          </div>

          {/* Hero visual */}
          <div className="flex justify-center lg:justify-end pr-0 lg:pr-12">
            <HeroPhone />
          </div>
        </div>

        {/* Growth Highlights */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto mt-20">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary-600">
              <div className="text-lg font-bold text-primary-600 mb-2">🏪 Support Local</div>
              <div className="text-gray-600 text-sm">Every order helps your community thrive</div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary-600">
              <div className="text-lg font-bold text-primary-600 mb-2">🎁 Earn Rewards</div>
              <div className="text-gray-600 text-sm">Exclusive offers at participating stores</div>
            </div>
          </div>
        </div>
    </section>
  )
}

export default Hero
